import { ref, toRaw, computed } from 'vue'
import { defineStore } from 'pinia'
import { saveMctUserPreferencesApi } from '@/api/home/user'
import { deepClone } from '@/utils/util'
import { timeZoneMap } from '@/utils/timezoneList'

export const useUserDefaultSettingStore = defineStore(
  'userDefaultSetting',
  () => {
    const userInfo = localStorage.getItem('MCT_USER_INFO')
      ? JSON.parse(localStorage.getItem('MCT_USER_INFO') as string)
      : {}

    const userName = ref(localStorage.getItem('DISPLAY_NAME') || '')
    const userCEC = ref(localStorage.getItem('USER_CEC') || '')
    const userId = ref(userInfo?.memberId || 0)
    const privilege = ref(userInfo?.privilege || 0)
    const department = ref(Number(userInfo?.department) || 0)

    const customizeService = ref(userInfo?.customizeService || '')
    // const hasAccess = ref(privilege.value === 0 ? false : [100, 200].includes(privilege.value) ? )
    const hasAccess = (serviceId: any) => {
      if (privilege.value === 255) {
        return true
      }
      if (privilege.value === 0) {
        return false
      }
      const customizeServiceList = customizeService.value?.split('_') || []
      if (serviceId ?? '' !== '') {
        if (customizeServiceList.includes(serviceId.toString())) {
          return true
        }
      }
      return false
    }
    // const preferences = {
    // preferences for MCT2.0
    //   Collapsed: false,
    //   StatusLazyNumber: 200,
    //   UnAckNumber: 10,
    //   ackInterval: 0,
    //   classicView: false,
    //   clusterViewEnvFilter: 'all',
    //   defaultView: 0,
    //   hideOneViewCard: false,
    //   hideService: false,
    //   hideUnack: false,
    //   markdownLog: false,
    //   popOverCheck: 15,
    //   showDCName: 0,
    //   showGlobal: false,
    //   showOwnSvs: false,
    //   showServiceName: 0,
    //   statusDuration: 2,
    //   themePicker: 'white',
    //   useLocalTimezone: '99'

    // preferences for MCT3.0
    //   alertOnly: number
    //   collapseLeftMenu: boolean
    //   theme: string
    //   defaultStatusDuration: number
    //   timezone: number
    // }
    const preferences = ref<any>(
      JSON.parse(localStorage.getItem('MCT_USER_PREFERENCES') as string) || {}
    )
    document.documentElement.className = preferences.value.theme

    const timeZone = ref(preferences.value?.timezone || 0)
    const timeZoneArea = computed(() => timeZoneMap[timeZone.value] || 'UTC')

    const setUser = () => {
      if (!localStorage.getItem('MCT_USER_INFO')) {
        return
      }
      const userInfo = JSON.parse(
        localStorage.getItem('MCT_USER_INFO') as string
      )
      userId.value = userInfo.memberId
      privilege.value = userInfo.privilege
      department.value = Number(userInfo?.department)
      customizeService.value = userInfo.customizeService

      preferences.value = JSON.parse(
        localStorage.getItem('MCT_USER_PREFERENCES') as string
      )

      timeZone.value = preferences.value?.timezone || 0
    }

    const setPreferences = async (refreshPage = true, refreshApi = true) => {
      const data = JSON.stringify(deepClone(toRaw(preferences.value)))
      localStorage.setItem('MCT_USER_PREFERENCES', data)
      // preferences.value = JSON.parse(data)
      if (refreshApi) {
        await saveMctUserPreferencesApi(userId.value, { preference: data })
      }
      refreshPage && location.reload()
    }

    const setLocalStorage = (key: string, value: any) => {
      localStorage.setItem(key, JSON.stringify(value))
    }

    const getLocalStorage = (key: string) => {
      // @ts-ignore
      return JSON.parse(localStorage.getItem(key) || null)
    }

    return {
      userName,
      userCEC,
      timeZone,
      timeZoneArea,
      userId,
      privilege,
      department,
      customizeService,
      preferences,
      hasAccess,
      setUser,
      setPreferences,
      setLocalStorage,
      getLocalStorage
    }
  }
)
